import axios from 'axios';

const PORT = process.env.REACT_APP_INTERNAL_SERVER_PORT || 5000;

const hostName = window.location.hostname;
let hostNameParts = hostName.split('.');
if (hostNameParts.length > 2) {
  hostNameParts[0] =
     process.env.REACT_APP_EXTERNAL_SERVER_SUBDOMAIN;
}
const externalHostname = hostNameParts.join('.');

const urlAuth = `${window.location.protocol}//${
  window.location.protocol === 'https:'
    ? externalHostname
    : window.location.hostname + ':' + PORT
}/auth`;

const register = (username, email, password) => {
  return axios.post(urlAuth + '/signup', {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  return axios
    .post(urlAuth + '/signin', {
      username,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem('user', JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  console.log('try to log out');
  localStorage.removeItem('user');
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

export default {
  register,
  login,
  logout,
  getCurrentUser,
};
